import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { WebRuntimeProvider } from "@tchoma/runtime-web";
import "@tchoma/ui-riri/styles.css";
import { App } from "./App";
import { CaptureHandoffReplayGuard, captureUrlWithoutFragment, type CaptureHandoffInput } from "./capture-handoff";
import manifest from "../tchoma.config";
import { createInboxRoutes, inboxServiceWorkerUrl } from "./routes";
import "./styles.css";

const inboxRoutes = createInboxRoutes(manifest.surfaces.web.publicUrl);
const captureGuard = new CaptureHandoffReplayGuard();
const initialCapture: CaptureHandoffInput = window.location.pathname.endsWith("/capture")
  ? captureGuard.consume(window.location.href)
  : { status: "absent" };
if (window.location.pathname.endsWith("/capture") && window.location.hash) {
  window.history.replaceState(window.history.state, "", captureUrlWithoutFragment(window.location.href));
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <WebRuntimeProvider
      routes={inboxRoutes}
      fallbackRouteId="inbox"
      serviceWorker={{ enabled: import.meta.env.PROD, url: inboxServiceWorkerUrl(manifest.surfaces.web.publicUrl) }}
    >
      <App initialCapture={initialCapture} />
    </WebRuntimeProvider>
  </StrictMode>,
);
